var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiveAgentLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 396,
    height: 235,
    viewBox: "0 0 396 235",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 157.985V13.4617C11 11.9227 12.6656 10.9604 13.999 11.7291L137.78 83.0969M11 157.985V222.174C11 223.713 12.6656 224.675 13.999 223.907L382.001 11.7291C383.334 10.9604 385 11.9227 385 13.4617V83.0969M11 157.985L137.78 83.0969M137.78 83.0969L261.39 154.366M261.39 154.366L382.001 223.907C383.334 224.675 385 223.713 385 222.174V83.0969M261.39 154.366L385 83.0969",
    stroke: "black",
    strokeWidth: 21
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveAgentLogo);
export default __webpack_public_path__ + "static/media/Live_Agent_Logo.4d12cbaf2cb48d27f3065259b5cdd845.svg";
export { ForwardRef as ReactComponent };